<template>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-12 mb-4">
      <div class="form-group">
        <label for="">{{ $t("choose_country") }}</label>
        <!-- v-model="Form.country_id" -->
        <Multiselect
          v-model="nationalitValues"
          @update:model-value="emitRadioSelected"
          :options="nationalities.map((nationality) => nationality.id)"
          :custom-label="(opt) => nationalities.find((x) => x.id == opt).title"
          :clear-on-select="true"
          :placeholder="$t('choose_nationality')"
          select-label=""
          :multiple="true"
          :hide-selected="true"
        >
        </Multiselect>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Multiselect from "vue-multiselect";

export default {
    name: "nationality-custom",
    components: {
      Multiselect  
    },
    data() {
        return {
          nationalities: [],
          nationalitValues: [],
        }
    },
    methods: {
      //fetch country
      fetch_nationalities() {
          axios.post("/fetch_nationalities").then(({ data }) => {
              this.nationalities = data.data;
              // console.log(this.countries);
          });
      },

      emitRadioSelected() {
        this.$emit('multiselect-changed', this.nationalitValues);
      },
    },
    created() {
        this.fetch_nationalities();
    }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<style lang="scss" scoped>
    @import "../../../view/setup/_setup.scss";
</style>